export interface IUserListItemUserGroup {
    name: string;
    companyName: string;
}

export class UserListItemUserGroup implements IUserListItemUserGroup {
    name: string;
    companyName: string;

    constructor();
    constructor(obj: IUserListItemUserGroup);
    constructor(obj?: any) {
        this.name = obj && obj.name || "";
        this.companyName = obj && obj.companyName || "";
    }
}